import { apiFunctions } from "../ApiService";
import siteUrls from "../SiteURLs";

export const verifyEmail = async (params, payload) => {
    return apiFunctions.post(`${siteUrls.passwordSet.verifyEmail}/${params}`, payload);
};

export const setPasswordApi = async (payload) => {
    return apiFunctions.post(siteUrls.passwordSet.setPassword, payload)
}